"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regions = void 0;
exports.regions = ['North East', 'South East', 'West', 'South West', 'Mid West'];
